import { Dispatch } from "redux";
import endOfDay from "date-fns/endOfDay";
import startOfDay from "date-fns/startOfDay";
import format from "date-fns/format";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import { resources } from "@constants/hardcoded-strings";
import { formatActivityLogs } from "@formatters/activity-logs/activity-log-formatter";
import { FormattedActivityLog } from "@idw-types/data/reports";
import {
    setOrganizationActivitySearchResults,
    setOrganizationActivitySearchResultsLoading
} from "@redux/actions/organization-activity-actions";
import { getActivityLogsRequest } from "@requests/reports/get-activity-logs";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";

export const getOrganizationActivityReduxRequest = (dispatch: Dispatch) => async (
    companyId: string,
    startDate: Date,
    endDate: Date
): Promise<Array<FormattedActivityLog>> => {
    dispatch(setOrganizationActivitySearchResultsLoading(true));
    const { data, error, queryParameters } = await getActivityLogsRequest(
        null,
        companyId,
        format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    if (data?.activityLogs) {
        const formattedOrganizationActivity = formatActivityLogs(data.activityLogs);
        dispatch(setOrganizationActivitySearchResults(formattedOrganizationActivity));
        return formattedOrganizationActivity;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getActivityLogs.error.title,
                resources.requests.getActivityLogs.error.message,
                null,
                queryParameters
            );
        }
        dispatch(setOrganizationActivitySearchResultsLoading(false));
        return null;
    }
};